import { createSelector } from "@ngrx/store";
import { State } from "src/app/store/app.state";
import { PropertiesState } from './properties.state';

export const selectPropertiesState = (state: State) => state.properties;

export const selectProperties = createSelector(
  selectPropertiesState,
  (state: PropertiesState) => {
    return state.properties;
  }
);

export const selectPropertyChart = (propertyId: number) =>
  createSelector(
    selectPropertiesState,
    (state: PropertiesState) => state.propertyCharts[propertyId]
  );
